/**
 * Jovii — THE TOP ROW'S GROUND, on a phone.
 *
 * The owner: the space behind Shows / Movies / JOVII, from the very top of the
 * screen, should be the hero's own image, scaled up and blurred until it is
 * only colour - "the same one piece on top of the asset". Not a tint, not a
 * fade to black.
 *
 * WHY THIS IS A STORE AND NOT A PSEUDO-ELEMENT ON THE HERO. The first two
 * attempts drew the echo INSIDE the hero, positioned above its top edge - and
 * the hero has `overflow: clip` (its stage overscans and must be cut), so the
 * echo was clipped to nothing on a phone. Verified on prod, logged in: the
 * element was there, 83px tall, at top:-19, painted inside a box that clips.
 *
 * The row is a sibling ABOVE the hero, in flow, so the picture cannot reach it
 * from inside the hero at all. Instead the hero (Home) or the title page
 * PUBLISHES which image is on screen, and BubbleNav paints that image as its
 * own background. One writer per screen; the row reads. A screen with no hero
 * publishes null and the row falls back to the plain ground.
 */

export const topGround: { src: string | null } = $state({ src: null });

/** Called by whichever screen owns the picture under the row. Returns a teardown. */
export function claimTopGround(src: string | null): () => void {
  topGround.src = src;
  return () => {
    if (topGround.src === src) topGround.src = null;
  };
}
